var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDismantleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M38,202.9c-1.1,0.8-2.7,0.4-3.4-0.7L20.4,181c-0.7-1.1-0.4-2.6,0.7-3.3l98-63.6l-5.6-8.3l-97.8,63.6c-5.8,3.8-7.4,11.4-3.7,17l14.1,21.2c1.9,2.8,4.8,4.6,7.9,5.2c3.2,0.7,6.6,0,9.5-1.8l97.5-63.3l-5.5-8.3L38,202.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M206.5,130L172,152.3c-0.3,0.2-0.8,0.2-1.2,0.1c-0.9-0.2-1.8-0.8-2.4-1.7l-63.4-94.8l32.5,15.8c7,3.3,15,4,20.3,1.9l9.6-3.4c0.2,0,0.5,0,0.9,0.1c0.5,0.2,1.5,1.1,2.1,2l35.9,53.7C207.4,127.6,207.3,129.4,206.5,130z M214.9,120.6L179.1,67c-0.5-0.8-3.2-4.9-7.6-6.2c-3.9-1.2-6.5-0.4-7.7,0.2l-9.4,3.3c-2.9,1.1-7.9,0.5-12.4-1.5l-39.4-19.1c-0.7-0.3-1.3-0.6-1.9-0.7c-2.3-0.5-4.3,0.2-4.9,0.5l-0.5,0.3c-1.9,1.1-3.3,2.7-3.8,4.7c-1,3.9,1.5,7.6,3.9,11.3l64.5,96.5c2,3.1,5.3,5.3,8.8,6c3.1,0.7,6.3,0,8.8-1.6l34.5-22.3C217.6,134.5,218.9,126.6,214.9,120.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M119.4,179.2v17h63.3L119.4,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M246,150.7l-11.5-11.3l-40.3,45.5L246,150.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDismantleIcon);
export default __webpack_public_path__ + "static/media/dismantle_icon.8bfcd5e9a48f8d3ae4dc3b322172b253.svg";
export { ForwardRef as ReactComponent };